import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { APIReducer } from 'store/apiReducer';
import compte from './compte/index';
import referentiel from './referentiel/index';
import recherche from './recherche';
import profil from './profil';
import armes from './armes';
import adresseVerificationBAN from './adresseVerificationBAN';
import notification from './notification';
import alertesMiddleware from './alertes/alertesMiddleware';
import alertes from './alertes';
import etapes from './etapes';
import monCompte from './mon-compte';
import fichier from './fichier';
import materiel from './materiel';
import mesDeclarationsArmes from './mesDeclarationsArmes';
import contact from './contact';
import repriseDeDonnees from './repriseDeDonnees';
import adresseExtensions from './adresseExtensions';
import { CLEAR_INFORMATIONS } from '../utils/utils';
import ceaf from './ceaf/index';
import { CONTEXT_GET_FEATURE_FLIPPING } from '../constants/apiUrls.constants';
import documentUtilisateur from './documentUtilisateur';
import deconnexionMiddleware from './deconnexion/deconnexionMiddleware';
import titreDetention from './titreDetention';
import mesDemarchesEtAutorisations from './demarchesEtAutorisation';

// Combine all reducers.
const appReducer = combineReducers({
    /** Import des stores */
    compte,
    referentiel,
    recherche,
    profil,
    armes,
    adresseVerificationBAN,
    notification,
    alertes,
    etapes,
    monCompte,
    fichier,
    materiel,
    mesDemarchesEtAutorisations,
    mesDeclarationsArmes,
    contact,
    repriseDeDonnees,
    adresseExtensions,
    ceaf,
    featureFlipping: APIReducer.bind(null, CONTEXT_GET_FEATURE_FLIPPING),
    documentUtilisateur,
    titreDetention,
});

const rootReducer = (state, action) => {
    // Clear all data in redux store to initial.
    if (action.type === CLEAR_INFORMATIONS) {
        // eslint-disable-next-line no-param-reassign
        state = undefined;
    }

    return appReducer(state, action);
};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
    rootReducer,
    composeEnhancer(applyMiddleware(thunk, alertesMiddleware, deconnexionMiddleware)),
);
